import actions from './actions'

const project = {
  state: null,
  mutations: null,
  actions
}

export default project



// WEBPACK FOOTER //
// ./src/store/keyword/index.js